export default "__VITE_ASSET__f5117ef5__"